<template lang="pug">
  div#appProdutividade
    vue-progress-bar
    div(
      v-if="loader.status"
      v-loading="loader.status",
      :element-loading-text="loader.text",
      v-loading.fullscreen.lock="true"
    )
    header
      main-header(
        :notificacao="false"
        :hasListagemModelo="false"
      )
    main.container
      .content
        router-view
</template>

<script>
import { mapState } from 'vuex'
import MainHeader from '@/components/MainHeader'

export default {
  components: {
    MainHeader
  },

  computed: {
    ...mapState({
      loader: state => state.loader
    })
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_variables.scss";

* {
  box-sizing: border-box;
  font-family: "Ubuntu", sans-serif;
}

header {
  width: 100%;
  z-index: 5;
}

main.modal-open {
  overflow-x: hidden;
  position: relative;
  z-index: 8;
}

#appProdutividade {
  width: 100%;
  height: 100%;

  /deep/ h1,
  /deep/ h2,
  /deep/ h3,
  /deep/ h4,
  /deep/ h5,
  /deep/ p {
    color: #424242;
  }

  /deep/ p {
    margin: 0 0 10px;
  }

  /deep/ main {
    height: calc(100vh - #{$header-size});
    width: 100%;
  }

  .container {
    display: flex;
    border-radius: 12px;
    width: 100%;
    min-height: 100%;
  }

  .content {
    width: 100%;
    padding: 20px 30px;
    overflow-y: scroll;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/sala_situacao/MainPage.vue